import { Layout } from 'antd';
import { LinkedinOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { HashLink } from 'react-router-hash-link';
import React from 'react';

const { Footer } = Layout;

export const FooterSection = () => {
  const { t } = useTranslation();

  return (
    <Footer className="relative bg-world-pattern bg-no-repeat bg-cover overflow-hidden bg-[#F1F1F3] px-4 md:px-16 lg:pt-10 pb-5 lg:pb-10 w-full">
      <div className="flex flex-col lg:flex-row justify-between items-center lg:items-start w-full">
        <div className="flex flex-col gap-2 justify-center items-center lg:items-start lg:justify-start lg:w-auto">
          <img
            src="/images/logo.svg"
            alt="Rixsus Logo"
            className="w-[120px] sm:w-[120px] md:w-[213px]"
          />
          <p className="w-[45%] text-[16px] text-center lg:text-left text-[#7B7B7B] leading-[24px]">
            {t('footer.markets')}
          </p>
        </div>

        <div
          className="
            flex flex-col md:flex-col lg:flex-row
            items-center lg:items-start
            gap-[50px] lg:gap-[100px]
            w-full
            md:w-auto lg:w-[587px]
            lg:absolute
            lg:left-[450px] lg:top-[20px]
            px-4 py-8
          "
        >
          <div className="flex flex-col items-center lg:items-start gap-2 w-auto min-w-[150px] h-[150px] mx-auto">
            <h5 className="text-[24px] leading-[26px] font-semibold text-black text-center whitespace-nowrap">
              Rixsus
            </h5>
            <nav className="flex flex-col items-center lg:items-start gap-2 text-[16px] leading-[24px] text-[#7B7B7B]">
              <HashLink
                smooth
                to="/#why"
                className="hover:text-black transition"
              >
                {t('common.why')}
              </HashLink>
              <HashLink
                smooth
                to="/#coverage"
                className="hover:text-black transition"
              >
                {t('footer.coverage')}
              </HashLink>
              <HashLink
                smooth
                to="/#features"
                className="hover:text-black transition"
              >
                {t('common.features')}
              </HashLink>
              <HashLink
                smooth
                to="/#contact"
                className="hover:text-black transition"
              >
                {t('common.contact')}
              </HashLink>
            </nav>
          </div>

          <div className="flex flex-col items-center lg:items-start gap-2 w-[260px] h-[70px] mx-auto">
            <h5 className="text-[24px] leading-[26px] font-semibold text-black text-center whitespace-nowrap">
              {t('common.legal')}
            </h5>
            <nav className="flex flex-col items-center lg:items-start gap-2 text-[16px] leading-[24px] text-[#7B7B7B]">
              <HashLink
                smooth
                to="/legal"
                className="hover:text-black transition"
              >
                {t('common.terms')}
              </HashLink>
              <HashLink
                smooth
                to="/legal"
                className="hover:text-black transition"
              >
                {t('common.policy')}
              </HashLink>
            </nav>
          </div>

          <div className="flex flex-col items-center lg:items-start gap-2 w-[150px] h-[160px] mx-auto">
            <h5 className="text-[24px] leading-[26px] font-semibold text-black text-center">
              {t('footer.resources')}
            </h5>
            <nav className="flex flex-col items-center lg:items-start gap-2 text-[16px] leading-[24px] text-[#7B7B7B]">
              <a
                href="https://rixsus.instatus.com/"
                target="_blank"
                className="hover:text-black transition"
                rel="noreferrer"
              >
                {t('footer.statusPage')}
              </a>
            </nav>
            <h5 className="text-[24px] pt-2 leading-[26px] font-semibold text-black text-center whitespace-nowrap">
              {t('footer.followUs')}
            </h5>
            <nav className="flex flex-col items-center lg:items-start text-[16px] leading-[24px] text-[#7B7B7B]">
              <a
                href="https://www.linkedin.com/company/rixsus"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-500 hover:text-blue-600 transition-colors text-xl"
                aria-label="LinkedIn"
              >
                <LinkedinOutlined />
              </a>
            </nav>
          </div>
        </div>
      </div>

      <div className="lg:mt-[40px] pt-2 border-t border-gray-300 grid grid-cols-2 h-[770px] md:h-[460px] lg:h-[320px] ">
        <div className="text-sm text-gray-400 lg:text-left">
          <p>{t('footer.pspDescription')}</p>
          <p>
            {t('footer.pspDisclaimer')}{' '}
            <a
              href="https://www.bcra.gob.ar/registro-de-proveedores-de-servicios-de-pago-resultados-por-tipo/?tipoPSP=1"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline"
            >
              {t('footer.pspDisclaimerBank')}
            </a>
          </p>{' '}
          <p>{t('footer.pspOtherJurisdictions')}</p>
        </div>
        <div className="text-sm text-gray-400 text-center lg:text-right">
          <p>{t('footer.rights')}</p>
          <p className="mt-1">{t('footer.bridging')}</p>
          <div className="mt-4 flex flex-col items-center lg:items-end gap-2">
            <p className="text-sm text-gray-400 text-center lg:text-right">
              {t('footer.regulationsCertifications')}
            </p>
            <div className="flex items-center gap-4">
              <a
                href="https://www.usuariosfinancieros.gob.ar/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:opacity-90 transition-opacity rounded-md px-2 py-1"
                aria-label="Banco Central de la República Argentina"
              >
                <img
                  src="https://rixsusassets.s3.us-east-2.amazonaws.com/ar/img/logo-banco-central-argentina.png"
                  alt="Banco Central de la República Argentina"
                  className="w-[186px] h-[72px] rounded-xl"
                />
              </a>
              <a
                href="https://rixsusassets.s3.us-east-2.amazonaws.com/ar/img/uifar.png"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:opacity-90 transition-opacity bg-white rounded-md px-2 py-1 border border-gray-200 w-[186px] h-[72px] flex items-center justify-center"
                aria-label="UIF AR"
              >
                <img
                  src="https://rixsusassets.s3.us-east-2.amazonaws.com/ar/img/uifar.png"
                  alt="UIF AR"
                  className="w-full h-full object-contain rounded-xl"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </Footer>
  );
};
